module.exports = __webpack_public_path__ + "img/conteudos_casas_title_02.e51fc239.png";